/* DS · Carrossel de videos (home): faixas que so andam na tela e player de tela cheia. */
(function () {
  "use strict";
  document.querySelectorAll("[data-cv]").forEach(function (sec) {
    if (sec.dataset.cvPronto) return;
    sec.dataset.cvPronto = "1";
    var lista = JSON.parse(sec.querySelector("[data-cv-lista]").textContent);

    // capas em duas etapas (as que entram de lado pela animacao estao cortadas
    // pela faixa e a carga preguicosa do navegador nunca as veria):
    // perto da tela, as 6 primeiras de cada faixa; na tela, as outras
    var solta = function (sel) { sec.querySelectorAll(sel).forEach(function (i) { i.loading = "eager"; }); };
    var perto = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      solta('img[data-cv-ordem="0"], img[data-cv-ordem="1"], img[data-cv-ordem="2"], img[data-cv-ordem="3"], img[data-cv-ordem="4"], img[data-cv-ordem="5"]');
      perto.disconnect();
    }, { rootMargin: "700px 0px" });
    perto.observe(sec);

    // as faixas so andam com a secao na tela
    var resto = false;
    new IntersectionObserver(function (es) {
      var dentro = es[0].isIntersecting;
      sec.classList.toggle("cv--na-tela", dentro);
      if (dentro && !resto) { resto = true; setTimeout(function () { solta('img[loading="lazy"]'); }, 1200); }
    }).observe(sec);

    var dlg = sec.querySelector("[data-cv-player]");
    var video = dlg.querySelector("video");
    var cont = dlg.querySelector("[data-cv-cont]");
    var prog = dlg.querySelector("[data-cv-prog]");
    var pausa = dlg.querySelector("[data-cv-pausa]");
    // sempre mudo, sem jeito de ligar o som (pedido de 29/09)
    video.muted = true; video.defaultMuted = true;
    video.addEventListener("volumechange", function () { if (!video.muted) video.muted = true; });
    var atual = 0;

    function mostra(i) {
      atual = (i + lista.length) % lista.length;
      video.poster = lista[atual].capa;
      video.src = lista[atual].src;
      cont.textContent = atual + 1 + " / " + lista.length;
      prog.style.transform = "scaleX(0)";
      video.muted = true;
      dlg.classList.remove("cv-player--pausado");
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    function abre(i) {
      if (!dlg.open) {
        dlg.showModal();
        document.documentElement.classList.add("cv-trava");
        sec.classList.add("cv--assistindo");
      }
      mostra(i);
    }
    function fecha() { if (dlg.open) dlg.close(); }

    dlg.addEventListener("close", function () {
      video.pause();
      video.removeAttribute("src");
      video.load();
      document.documentElement.classList.remove("cv-trava");
      sec.classList.remove("cv--assistindo");
    });
    sec.addEventListener("click", function (e) {
      var b = e.target.closest("[data-cv-i]");
      if (b) abre(+b.dataset.cvI);
    });
    dlg.querySelector("[data-cv-fechar]").addEventListener("click", fecha);
    dlg.querySelector("[data-cv-ant]").addEventListener("click", function () { mostra(atual - 1); });
    dlg.querySelector("[data-cv-prox]").addEventListener("click", function () { mostra(atual + 1); });
    video.addEventListener("ended", function () { mostra(atual + 1); });
    video.addEventListener("timeupdate", function () { if (video.duration) prog.style.transform = "scaleX(" + (video.currentTime / video.duration).toFixed(3) + ")"; });
    function alterna() {
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } else video.pause();
    }
    video.addEventListener("play", function () { dlg.classList.remove("cv-player--pausado"); pausa.setAttribute("aria-label", "Pausar o vídeo"); });
    video.addEventListener("pause", function () { dlg.classList.add("cv-player--pausado"); pausa.setAttribute("aria-label", "Continuar o vídeo"); });
    pausa.addEventListener("click", alterna);
    video.addEventListener("click", alterna);
    // 720p que nao existe (video antigo): volta para a versao original
    video.addEventListener("error", function () {
      var it = lista[atual];
      if (it.orig && video.src.indexOf(it.orig) === -1 && it.src !== it.orig) { video.src = it.orig; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    });
    // toque fora do video (no fundo do dialogo) fecha
    dlg.addEventListener("click", function (e) { if (e.target === dlg) fecha(); });
    dlg.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") mostra(atual + 1);
      else if (e.key === "ArrowLeft") mostra(atual - 1);
    });
  });
})();
